import { render } from "./AssetComp.vue?vue&type=template&id=e050aa86"
import script from "./AssetComp.vue?vue&type=script&lang=js"
export * from "./AssetComp.vue?vue&type=script&lang=js"

import "./AssetComp.vue?vue&type=style&index=0&id=e050aa86&lang=css"

import exportComponent from "D:\\Github\\cj-assets\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__